export default {"src":"/_next/static/media/ZipRecruiter.7c4e0061.svg","height":41,"width":179,"blurWidth":0,"blurHeight":0};